// test953
(953 && 0);
